var isMarketoPopupTriggered = false;
var urlRegex = new RegExp('^(?:[a-z]+:)?//', 'i');
var isFirstBrowserScroll = true;
var makeFooterSubscriptionStatic = true;
var isVideoPopupOpened = false;
window.isAnyPopupOpen = false;

const TimeZoneMap = {
    "IST": "Asia/Calcutta",
    "EST": "America/New_York",
    "ET": "America/New_York",
    "MST": "America/Boise",
    "UTC": "Etc/UTC",
};

const WaWApp = {
    IDP: 0,
    WWW: 1,
    INDIA: 2,
    MENA: 3,
    All: 4
}

const CertificationStatus = {
    None: 0,
    Active: 1,
    InGracePeriod: 2,
    Expired: 3
};

const ContentType = {
    None: 0,
    Article: 1,
    Tool: 2,
    Book: 3,
    Certification: 4,
    Course: 5,
    Event: 6,
    Research: 7,
    Webinar: 8
};

const affiliateLocationData = (function () {
    try {
        var data = window.affiliateLocationData;
        if (typeof data === 'string') {
            data = JSON.parse(data);
        }
        if (data && Array.isArray(data.countries) && data.states && typeof data.states === 'object') {
            return data;
        }
    } catch (e) { /* ignore */ }
    return { countries: [], states: {} };
})();

const countryDataset = affiliateLocationData.countries;
const stateDataset = affiliateLocationData.states;

(function () {
    // Mobile-app marker: tab-scoped so it survives in-tab navigation (cart -> checkout -> order confirmation)
    var queryIsMobileApp = false;
    try { queryIsMobileApp = new URLSearchParams(window.location.search).get('ismobileapp') === 'true'; } catch (e) { }
    var sessionIsMobileApp = false;
    try {
        if (queryIsMobileApp) {
            sessionStorage.setItem('waw_ismobileapp', 'true');
        }
        sessionIsMobileApp = sessionStorage.getItem('waw_ismobileapp') === 'true';
    } catch (e) { }
    window.isMobileAppRequest = queryIsMobileApp || sessionIsMobileApp;


    // Remove the legacy long-lived domain-wide IsMobileApp cookie
    try {
        if (document.cookie.indexOf('IsMobileApp=') !== -1) {
            document.cookie = 'IsMobileApp=; path=/; max-age=0';
            if (location.hostname !== 'localhost') {
                document.cookie = 'IsMobileApp=; path=/; domain=worldatwork.org; max-age=0';
            }
        }
    } catch (e) { }
})();

$(document).ready(function () {
    // Server may have rendered the feedback button when only the tab-scoped mobile-app marker knows to suppress
    if (window.suppressPopups) {
        $('.feedback-button').addClass('d-none');
    }

    //this is for fixed menu and remove scroll bar tablet and mobile devices

    $('button.main-nav-bar-toggler').click(function () {
        mobileMenuToggler();
    });

    $(".navbar-collapse #menu .nav-item .nav-link").click(function () {
        if (!$(".navbar-collapse").hasClass("menuHideAndDisplay")) {
            $('.navbar-collapse').collapse('hide');
            mobileMenuToggler();
        }
    });

    function mobileMenuToggler() {
        $('#navbarNav').toggleClass('menuHideAndDisplay');
        $('.header-container').toggleClass('menuFixed');
        if ($('.header-container').hasClass('menuFixed')) {
            $('.header-container').css("z-index", getMaxZIndex() + 1);
        } else {
            $('.header-container').css("z-index", 1);
        }
        $('body').toggleClass('ScrollOff');
    }

    //this is for fixed menu and remove scroll bar tablet and mobile devices

    //this is for the sticky header while scrolling
    var scrollClassAdd = document.getElementById("scroll-nav-add-rem");
    $(window).scroll(function () {
        if ($(this).scrollTop() > 50) {
            if (scrollClassAdd) {
                scrollClassAdd.classList.add("scroll-nav");
            }
            if (typeof (isBannerEnabled) != "undefined" && isBannerEnabled) {
                hideBanner();
            }
        }
        else {
            if (scrollClassAdd) {
                scrollClassAdd.classList.remove("scroll-nav");
            }
            if (typeof (isBannerEnabled) != "undefined" && isBannerEnabled) {
                showBanner();
            }
        }
        menuSelectionOnScroll();
    });

    //Scroll to top button

    var scrollToTopBtn = document.querySelector(".scrollToTopBtn");
    var footerSubSection = document.querySelector("#footerSub");
    var rootElement = document.documentElement;

    function handleScroll() {
        // Do something on scroll
        var scrollTotal = rootElement.scrollHeight - rootElement.clientHeight;
        if (rootElement.scrollTop / scrollTotal > 0.4) {
            // Show button
            scrollToTopBtn.classList.add("showscrollToTopBtn");
        } else {
            // Hide button
            scrollToTopBtn.classList.remove("showscrollToTopBtn");
        }

        if (footerSubSection != null) {
            if (rootElement.scrollTop / scrollTotal > 0.2 && !window.wawUser.hasWorkspanWeeklySubscription && !makeFooterSubscriptionStatic) {
                footerSubSection.classList.add("sticky-bottom");
            } else {
                footerSubSection.classList.remove("sticky-bottom");
            }
        }
    }

    function scrollToTop() {
        // Scroll to top logic
        rootElement.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }

    scrollToTopBtn.addEventListener("click", scrollToTop);
    document.addEventListener("scroll", handleScroll);

    //Scroll to top button

    //Menu - Activate on scroll

    var lastId,
        topMenu = $("#scroll-nav-add-rem"),
        topMenuHeight = topMenu.outerHeight() + 10,
        menuItems = topMenu.find(".customMenu a"),
        menuItemsArray = [...menuItems].map(function (e) { return $(e).attr("href") }).filter(x => x.startsWith("#")),
        widgetIdsArray = [...$(".renderWidgetBlock")].map(function (e) { return '#' + $(e).attr("id") });
    scrollItems = menuItemsArray.sort(function (a, b) {
        return widgetIdsArray.indexOf(a) - widgetIdsArray.indexOf(b);
    });

    function menuSelectionOnScroll() {
        if (scrollItems.length > 0) {
            var fromTop = $(this).scrollTop() + topMenuHeight;
            var cur = scrollItems.map(function (e) {
                if ($(e)?.offset()?.top < fromTop)
                    return e;
            }).filter(x => x != undefined);
            var id = cur[cur.length - 1];
            if (lastId !== id) {
                lastId = id;
                menuItems
                    .removeClass("active")
                    .filter("[href='" + id + "']").addClass("active");
            }
        }
    }

    //Menu - Activate on scroll

    //Update all anchor tags with target=_blank whose href points to a different domain than the current domain
    var currentDomain = location.host;
    currentDomain = new RegExp(currentDomain, "i");

    var anchorTags = document.getElementsByTagName('a');
    for (var i = 0; i < anchorTags.length; i++) {
        try {
            var host = anchorTags[i].host;
            var href = anchorTags[i].href;

            var possibleExternalHrefs = ["/lms-sso", "/engage-sso", "/career-sso", "/psi-sso", "/canvas-sso", "/squirrel-sso", "/wagescape-sso"];
            var possibleStartWithExternalHrefs = ["/foundation/scholarship-application/"];

            var globalUrlToReplace = "%7Burl.global%7D";
            var indiaUrlToReplace = "%7Burl.india%7D";
            var menaUrlToReplace = "%7Burl.mena%7D";
            var memberAccessUrlToReplace = "%7Burl.member%7D";

            if (!isNullOrWhitespace(href) && new URL(href).origin != AppConfig_AppPaths_IDPURL.value && href.indexOf("javascript:void(0)") < 0) {
                if (!currentDomain.test(host) || possibleExternalHrefs.includes(new URL(href).pathname)
                    || possibleStartWithExternalHrefs.some(function (link) { return new URL(href).pathname.startsWith(link) })
                    || isFile(href) || host.indexOf("." + location.host) > -1) {
                    anchorTags[i].setAttribute('target', '_blank');
                    anchorTags[i].innerHTML += "<span class='sr-only' aria-hidden='true'>Open in a new tab</span>";

                    let checkEmail = anchorTags[i].href.indexOf("mailto:");
                    if (checkEmail > -1) {
                        anchorTags[i].innerHTML += "<span class='sr-only' aria-hidden='true'>Email</span>";
                    }
                }

                if (href.includes(globalUrlToReplace)) {
                    var urlToSet = anchorTags[i].pathname.substring(anchorTags[i].pathname.indexOf("%7B"), anchorTags[i].pathname.length);
                    href = urlToSet.replace(globalUrlToReplace, AppConfig_AppPaths_WebURL.value);
                    anchorTags[i].setAttribute("href", href + anchorTags[i].search + anchorTags[i].hash);
                    anchorTags[i].setAttribute('target', '_blank');
                }

                if (href.includes(indiaUrlToReplace)) {
                    var urlToSet = anchorTags[i].pathname.substring(anchorTags[i].pathname.indexOf("%7B"), anchorTags[i].pathname.length);
                    href = urlToSet.replace(indiaUrlToReplace, AppConfig_AppPaths_INDIAURL.value);
                    anchorTags[i].setAttribute("href", href + anchorTags[i].search + anchorTags[i].hash);
                    anchorTags[i].setAttribute('target', '_blank');
                }

                if (href.includes(menaUrlToReplace)) {
                    var urlToSet = anchorTags[i].pathname.substring(anchorTags[i].pathname.indexOf("%7B"), anchorTags[i].pathname.length);
                    href = urlToSet.replace(menaUrlToReplace, AppConfig_AppPaths_MENAURL.value);
                    anchorTags[i].setAttribute("href", href + anchorTags[i].search + anchorTags[i].hash);
                    anchorTags[i].setAttribute('target', '_blank');
                }

                if (anchorTags[i].textContent === "Learn More") {
                    anchorTags[i].innerHTML += "<span class='sr-only' aria-hidden='true'>Learn More</span>";
                }

                if (href.includes(memberAccessUrlToReplace)) {

                    var urlToSet = anchorTags[i].pathname.substring(anchorTags[i].pathname.indexOf("%7B"), anchorTags[i].pathname.length);

                    var memberUrl = urlToSet.replace(memberAccessUrlToReplace, "");

                    if (window.wawUser.id != null && window.wawUser.hasAccessToMemberBenefits) {
                        anchorTags[i].setAttribute("href", memberUrl);

                        if (!memberUrl.startsWith("/") && !currentDomain.test(memberUrl)) {
                            anchorTags[i].setAttribute('target', '_blank');
                        }

                    } else {
                        anchorTags[i].setAttribute("href", "#memberOnlyAccessDenied");
                        anchorTags[i].setAttribute("data-href", memberUrl);
                        anchorTags[i].setAttribute('target', '');
                    }
                }
            }
        } catch (ex) {
            console.log(ex);
        }
    }
    //Update all anchor tags with target=_blank whose href points to a different domain than the current domain

    // Scroll to ID

    $("a[href^='#']").on("click", function (event) {
        var href = $(this).attr("href");
        var doScroll = href != "#";
        if (href == "#main" || href.startsWith("#mktoForm") || $(event.currentTarget).hasClass("glosseriesAlphabetBox")) {
            return;
        }

        if (href == "#memberOnlyAccessDenied") {
            openMemberOnlyAccessDenied(event);
        }
        else if (href == "#print_page") {
            window.print();
        }
        else if (doScroll) {
            var hrefWithoutHash = href.substring(1);
            scrollOnPagination(hrefWithoutHash);
        }

        event.preventDefault();
    });

    // Scroll to ID

    //Add border-bottom for the active menu
    var pathname = "/" + window.location.pathname.split("/")[1];
    $("ul.navbar-nav > li.nav-item > a.nav-link[href='" + pathname + "']").addClass("active");
    //Add border-bottom for the active menu

    //Search box

    $(".waw_searchBox input").keydown(function (event) {
        if (event.which === 13) {
            event.preventDefault();

            var keyword = $(this).val();
            var url = window.location.origin;

            if (keyword.trim() != "") {
                url += "/search/Init?q=" + keyword;
            }

            window.location.replace(url);
        }
    });

    //Search box

    //slick slider script

    if ($('.subNavGradientBlockMultipleItems').length > 0) {

        $('.subNavGradientBlockMultipleItems').slick({
            infinite: false,
            dots: false,
            accessibility: true,
            slidesToShow: 7,
            slidesToScroll: 1,
            prevArrow: '<div class="slick-prev slick-arrow" role="button" tabindex="0"><img loading="lazy" src="/img/icons/arrow-left.svg" /><span class="sr-only" aria-hidden="true">Previous</span></div>',
            nextArrow: '<div class="slick-next slick-arrow" role="button" tabindex="0"><img loading="lazy" src="/img/icons/arrow-right.svg" /><span class="sr-only" aria-hidden="true">Next</span></div>',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 5,
                        dots: false
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        dots: false
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                }
            ]
        });

        setTimeout(function () {
            var subNavSlick = $('.subNavGradientBlockMultipleItems').slick('getSlick');
            var subNavMenus = subNavSlick.$slides;

            subNavMenus.toArray().forEach(function (menu) {
                if (menu.classList.contains("active")) {
                    subNavSlick.slickGoTo(menu.dataset.slickIndex);
                }
            });
        }, 1000);

        var arrowSelector = $('.subNavGradientBlockMultipleItems > .slick-arrow');
        arrowSelector.off("click");
    }

    //For Conference Sub menu
    if ($('.SubMenu-Area').length > 0) {
        $('.SubMenu-Area').slick({
            infinite: false,
            dots: false,
            accessibility: true,
            slidesToShow: 5,
            slidesToScroll: 1,
            prevArrow: '<div class="slick-prev slick-arrow" role="button" tabindex="0"><img loading="lazy" src="/img/icons/arrow-left.svg" /><span class="sr-only" aria-hidden="true">Previous</span></div>',
            nextArrow: '<div class="slick-next slick-arrow" role="button" tabindex="0"><img loading="lazy" src="/img/icons/arrow-right.svg" /><span class="sr-only" aria-hidden="true">Next</span></div>',
            variableWidth: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: false,
                        dots: false
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        infinite: false,
                        dots: false
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        infinite: false,
                    }
                }
            ]
        });

        setTimeout(function () {
            var subNavSlick = $('.SubMenu-Area').slick('getSlick');
            var subNavMenus = subNavSlick.$slides;

            subNavMenus.toArray().forEach(function (menu) {
                if (menu.children[0].classList.contains("active")) {
                    subNavSlick.slickGoTo(menu.dataset.slickIndex);
                }
            });
        }, 1000);

        var arrowSelector = $('.SubMenu-Area > .slick-arrow');
        arrowSelector.off("click");
    }
    //slick slider script

    var retryCounter = 0;

    function checkAndLoadGA() {
        if ((typeof ga === "function" && ga.loaded) || retryCounter++ > 20) {
            Ecommerce.init();
        } else {
            setTimeout(checkAndLoadGA, 500);
        }
    }

    //Update all img tags with alt and title

    function updateImageAltTitle() {
        var imgTags = document.getElementsByTagName('img');

        for (let i = 0; i < imgTags.length; i++) {
            try {
                //We can set the alt text as Image name if needed in future.
                //var imgName = imgTags[i].src.replace(/^.*[\\\/]/, "");

                //imgName = imgName.replace(/(.*)\.(.*?)$/, "$1")
                //    .replaceAll("%20", " ")
                //    .replace(/\d{1,5}x\d{1,5}/, "")
                //    .replace(/_/g, " ")
                //    .replaceAll(/-/g, " ")
                //    .replaceAll("  ", "");

                //imgName = imgName.trim();

                if (!imgTags[i].alt) {
                    var pageTitle = $("title").text();
                    imgTags[i].alt = pageTitle;
                }
            } catch (ex) {

            }
        }
    }

    //Update all img tags with alt and title

    function setLastVisitedPage() {
        var lastVisitedPage = localStorage.getItem("lastVisitedPage");
        var currentPage = location.href;

        if (location.pathname == '/volunteer/volunteer-application') {
            if (!localStorage.getItem("lastVisitedVolunteerPage")) {
                localStorage.setItem("lastVisitedVolunteerPage", lastVisitedPage);
            }
            else {
                lastVisitedPage = localStorage.getItem("lastVisitedVolunteerPage");
            }
        }
        else {
            localStorage.removeItem("lastVisitedVolunteerPage")
        }

        if (lastVisitedPage && currentPage && lastVisitedPage != currentPage) {
            $(".header_close").attr("href", lastVisitedPage);
        }

        localStorage.setItem("lastVisitedPage", currentPage);
    }

    //check for video links for modal addition
    var maxVideoHeight = 896;
    $(window).resize(function () {
        resizeVideoPopup();
        resizeVideoPopup(true);
    });

    function resizeVideoPopup(isOnboardingVideo = false) {
        const videoPrefix = isOnboardingVideo ? '_onboardingvideo_' : '_video_';
        const popIdPrefix = isOnboardingVideo ? '#popOnboardingVideoID' : '#popVideoID';
        const $iframe = isOnboardingVideo ? $('#onboardingVideoEmbed') : $('#videoEmbed');

        var videoHeight = window.innerHeight - 49;
        if (videoHeight < maxVideoHeight) {
            $iframe.css('height', videoHeight);
        }
        else {
            $iframe.css('height', maxVideoHeight);
        }

        var popId = 0;
        $('a').each(function () {
            var value = $(this).attr('href');
            if (value != undefined) {
                if (value.startsWith(videoPrefix)) {
                    if ($(this).html().toLowerCase().includes('<img')) {
                        var imgHeight = $(this).children().innerHeight();
                        popId = popId + 1;
                        $(popIdPrefix + popId).css({
                            height: imgHeight
                        });
                    }
                }
            }
        });
    }

    //Append permalinks to each renderWidgetBlock
    $(".renderWidgetBlock").each(function () {

        var id = $(this).attr("id");

        if (id) { //make sure the element has an id
            $(this).append($("<a/>", {
                href: "#" + $(this).attr("id"),
                text: "¶",
                class: "widget-permalink"
            }));
        }
    });

    $(document).on("click", ".permalink", function () {
        copyPermalinkToClipboard($(this));
    });

    function copyPermalinkToClipboard(element) {
        var $temp = $("<input>");
        $("body").append($temp);
        $temp.val(window.location.origin + window.location.pathname + window.location.search + element.attr("href")).select();
        document.execCommand("copy");
        $temp.remove();

        showToast("Link copied to clipboard.", 4000, "success");
    }

    //Show tooltip for clamped contents

    $(".waw-show-tooltip").on("mouseover", (function () {

        $(this).removeAttr("title");

        if (this.offsetWidth < this.scrollWidth || this.offsetHeight < this.scrollHeight) {
            $(this).tooltip({
                title: $(this).text(),
                placement: "right",
                delay: { show: 1000, hide: 100 },
                html: true,
                template: "<div class='tooltip' role='tooltip'><div class='tooltip-arrow'></div><div class='tooltip-inner'>" + $(this).text() + "</div></div>"
            });
        }
    }));

    //Show tooltip for clamped contents

    //Open member landing page

    function openMemberLandingPage() {
        var query = new URLSearchParams(window.location.search);
        var memberLandingPage = query.get("returnToMemberPage");

        if (memberLandingPage) {
            var url = memberLandingPage;

            if (urlRegex.test(memberLandingPage)) {
                let domainThirdParty = (new URL(memberLandingPage));
                let domainSelf = (new URL(window.location.href));
                if (domainThirdParty == domainSelf) {
                    url = window.location.origin + url;
                }
            }
            else if (isFile(memberLandingPage)) {
                url = window.location.origin + url;
            }

            if (isMember && isMember.toLocaleString() == "true" && hasAccessToMemberBenefits) {
                window.open(url, '_blank').focus();
                window.location = window.location.pathname;
            } else {
                openMemberOnlyAccessDenied(null, memberLandingPage);
            }
        }
    }

    function applyWawTableWrapper() {
        try {
            const wawTables = $('table.waw-table');

            if (wawTables.length > 0) {
                const $articleContentSection = $('.article-content-section');
                const isInsideArticle = $articleContentSection.find('table.waw-table').length > 0;

                wawTables.each(function () {
                    if (!$(this).parent().hasClass('waw-table-wrapper')) {
                        $(this).wrap('<div class="waw-table-wrapper"></div>');
                    }

                    if (!isInsideArticle) {
                        $(this).parent().parent().css({ 'min-width': '0' });
                    }
                });
            }
        } catch (ex) {
        }
    }

    //Open member landing page

    //Update all <a> tags with role equals to button

    function UpdateButtonsWithRoleAttribute() {
        var aTags = document.getElementsByTagName('a');

        for (let i = 0; i < aTags.length; i++) {

            let checkUrl = aTags[i].href.indexOf("#");
            // Only set attribute below for links that have no role attribute and the href is not #
            if ((!aTags[i].attributes.role || !aTags[i].attributes.role.value) && checkUrl === -1) {
                aTags[i].setAttribute("role", "button");
                aTags[i].setAttribute("tabindex", "0");
            }

            // Set attribute only for href that started with # like Marketo form
            if (checkUrl > -1) {
                aTags[i].setAttribute("role", "button");
            }
        }
    }

    //Update all <a> tags with role equals to button

    updateCartLinkInMenu();
    updateImageAltTitle();
    checkAndLoadGA();
    setMaxZindexForModal();
    setLastVisitedPage();
    waitForMktoForms2(() => {
        MktoForms2.whenReady(onMarketoFormReady);
    });
    openMemberLandingPage();
    triggerURLScroll();
    UpdateButtonsWithRoleAttribute();

    makeFooterSubscriptionStatic = getCookie('makeFooterSubscriptionStatic');

    if (!checkFlexGap()) {
        $("body").addClass("no-flexbox-gap");
    }

    setTimeout(function () {
        var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
        popoverTriggerList.map(function (popoverTriggerEl) {
            if (popoverTriggerEl.attributes["data-bs-content"] != undefined) {
                return new bootstrap.Popover(popoverTriggerEl);
            }
        });
    }, 1000);

    applyWawTableWrapper();
    loadProfileDataCollectionPopup();
});

window.onload = function () {
    var currentQuery = new URLSearchParams(window.location.search);
    var vdCategoryFromUrl = currentQuery.get("vdcategory");

    if (vdCategoryFromUrl) {
        setTimeout(
            window.scrollTo({
                top: $("#vendorList").position().top - 200,
                behavior: "smooth"
            }), 3000);
    }

    setTimeout(function () {
        loadVideoPlayButtons();
        loadVideoPlayButtons(true);
    }, 1000);

    const sectionId = currentQuery.get("section");
    if (sectionId) {
        scrollOnPagination(sectionId);
    }
}

function isFile(url) {
    var urlPath = url;
    if (urlRegex.test(url)) {
        urlPath = new URL(url).pathname;
    }

    if (urlPath) {
        return urlPath.split("/").pop().indexOf(".") > 0;
    }

    return false;
}

function getOrchardImageMediaText(cmsImage) {
    if (cmsImage != null && cmsImage.MediaTexts != null && cmsImage.MediaTexts.Count != 0) {
        return cmsImage.MediaTexts[0];
    }

    return "";
}

function formatMediaUrl(path, storageType) {
    if (!path || (typeof path === 'string' && path.trim() === '')) {
        return '';
    }

    if (storageType === 'CantoCDN') {
        return path;
    }

    const cleanPath = path.startsWith('/') ? path.substring(1) : path;
    return '/media/' + cleanPath;
}

function getMediaUrl(mediaField, index = 0) {
    try {
        if (!mediaField) {
            return '';
        }

        if (!mediaField.Paths || !Array.isArray(mediaField.Paths) || index >= mediaField.Paths.length) {
            return '';
        }

        const path = mediaField.Paths[index];

        let storageType = 'AzureBlob';
        if (mediaField.StorageTypes &&
            Array.isArray(mediaField.StorageTypes) &&
            index < mediaField.StorageTypes.length &&
            mediaField.StorageTypes[index]) {
            storageType = mediaField.StorageTypes[index];
        }

        return formatMediaUrl(path, storageType);

    } catch (ex) {
        console.error('getMediaUrl error:', ex);
        try {
            if (mediaField && mediaField.Paths && mediaField.Paths[index]) {
                return formatMediaUrl(mediaField.Paths[index], 'AzureBlob');
            }
        } catch (innerEx) {
            console.error('getMediaUrl fallback error:', innerEx);
        }
        return '';
    }
}

function getMediaUrlFromPath(path, storageType) {
    try {
        if (!path || (typeof path === 'string' && path.trim() === '')) {
            return '';
        }

        const effectiveStorageType = (storageType && storageType.trim() !== '') ? storageType : 'AzureBlob';

        return formatMediaUrl(path, effectiveStorageType);

    } catch (ex) {
        console.error('getMediaUrlFromPath error:', ex);
        try {
            if (path) {
                return formatMediaUrl(path, 'AzureBlob');
            }
        } catch (innerEx) {
            console.error('getMediaUrlFromPath fallback error:', innerEx);
        }
        return '';
    }
}

function openMemberOnlyAccessDenied(event, url) {

    var returnUrl = "";

    if (event) {
        returnUrl = $(event.target).attr("data-href");
    } else {
        returnUrl = url;
    }

    var setLandingPage = false;
    var href = "/wawlogin?returnTo=" + encodeURIComponent(returnUrl);

    if (urlRegex.test(returnUrl)) {
        let domainThirdParty = (new URL(returnUrl));
        let domainSelf = (new URL(window.location.href));
        if (domainThirdParty != domainSelf) {
            setLandingPage = true;
        }
    }
    else if (isFile(returnUrl)) {
        setLandingPage = true;
    }

    if (setLandingPage) {
        var pageUrl = window.location.pathname + window.location.search;
        href = "/wawlogin?returnTo=" + encodeURIComponent(pageUrl);// + "%3FreturnToMemberPage%3D" + returnUrl;
        //uncomment the above and users will return to the same page with a landing page in query string which will be opened in a new tab.
        //But browsers will give security issues for opening a popup.
    }

    $(".memberonlyAccessDeniedLoginButton").attr("href", href);

    $("#MemberOnlyAccessDenied").modal("show");

    if (event) {
        event.preventDefault();
    }
}

function openLoginAccessDenied(event, url, showCreateAccount, displayContent) {

    var returnUrl = "";
    var isDonationProduct = false;
    var quantity = 0;
    var setLandingPage = false;

    if (event) {
        returnUrl = $(event.target).attr("data-href");
        isDonationProduct = $(event.target).attr("data-isDonationProduct");
        quantity = $(event.target).attr("quantity");
    } else {
        returnUrl = url;
    }

    var href = "/wawlogin?returnTo=" + encodeURIComponent(returnUrl);

    if (urlRegex.test(returnUrl)) {
        let domainThirdParty = (new URL(returnUrl));
        let domainSelf = (new URL(window.location.href));
        if (domainThirdParty != domainSelf) {
            setLandingPage = true;
        }
    }
    else if (isFile(returnUrl)) {
        setLandingPage = true;
    }

    if (setLandingPage) {
        var pageUrl = window.location.pathname + window.location.search;
        href = "/wawlogin?returnTo=" + encodeURIComponent(pageUrl);// + "%3FreturnToMemberPage%3D" + returnUrl;
        //uncomment the above and users will return to the same page with a landing page in query string which will be opened in a new tab.
        //But browsers will give security issues for opening a popup.
    }

    if (isDonationProduct) {
        $(".loginAccessDeniedLoginButton").attr("href", href + ((decodeURIComponent(href).match(/\?/g) || []).length > 1 ? "%26quantity%3D" : "%3Fquantity%3D") + quantity);
        $("#loginAccessDeniedDesc").html("Please log into your account to continue making your donation.");
    } else {
        $(".loginAccessDeniedLoginButton").attr("href", href);
        $("#loginAccessDeniedDesc").html(
            !isNullOrWhitespace(displayContent)
                ? displayContent
                : "Please log into your account now to access this content."
        );
    }

    if (showCreateAccount) {
        var accountRegUrl = AppConfig_AppPaths_IDPURL.value + "/auth/register?ReturnURL=" + encodeURIComponent(url);
        $(".create-acnt-link").show();
        $(".create-acnt-link a").attr("href", accountRegUrl)
    }

    $("#loginAccessDenied").modal("show");

    if (event) {
        event.preventDefault();
    }
}

//Get Max Z-Index

function getMaxZIndex() {
    return Math.max.apply(null,
        $.map($('body *'), function (e, n) {
            if ($(e).css('position') != 'static') {
                let maxZIndex = parseInt($(e).css('z-index'));
                //Due to some browser extension the z-index has been set to high. To avoid this kind of issue we are returning 2147483600 if we get max z index morethan 2147483600.
                if (maxZIndex > 2147483600) {
                    return 2147483600;
                }
                else {
                    return maxZIndex || 1;
                }
            }
        }));
}
//Get Max Z-Index

//Update cart link in menu

function setMaxZindexForModal() {
    let maxIndex = getMaxZIndex();
    $(".modal-backdrop").css("z-index", maxIndex + 1);
    $(".modal").css("z-index", maxIndex + 2);
}

function blurBackground() {
    $("div.body-content > div:not(#profile-pic-modal, #MemberOnlyAccessDenied), div.body-content > section, div.wawbreadcrumb, div#footer, header").css({ "filter": "blur(20px)", "-webkit-filter": "blur(20px)" });
}

function unBlurBackground() {
    $("div.body-content > div, div.body-content > section, div.wawbreadcrumb, div#footer, header").css({ "filter": "none", "-webkit-filter": "none" });
}

document.addEventListener('hide.bs.modal', function (event) {
    if (typeof (event.target.id) != "undefined" && event.target.id == "MemberOnlyAccessDenied") {
        unBlurBackground();
    }
});

document.addEventListener('show.bs.modal', function (event) {
    if (event && event.relatedTarget) {
        var returnUrl = $(event.relatedTarget).attr("data-href");
        var setLandingPage = false;
        var href = "/wawlogin?returnTo=" + encodeURIComponent(returnUrl);

        if (urlRegex.test(returnUrl)) {
            let domainThirdParty = (new URL(returnUrl));
            let domainSelf = (new URL(window.location.href));
            if (domainThirdParty != domainSelf) {
                setLandingPage = true;
            }
        }
        else if (isFile(returnUrl)) {
            setLandingPage = true;
        }

        if (setLandingPage) {
            var pageUrl = window.location.pathname + window.location.search;
            href = "/wawlogin?returnTo=" + encodeURIComponent(pageUrl);// + "%3FreturnToMemberPage%3D" + returnUrl;
            //uncomment the above and users will return to the same page with a landing page in query string which will be opened in a new tab.
            //But browsers will give security issues for opening a popup.
        }

        $(".memberonlyAccessDeniedLoginButton").attr("href", href);

        if (typeof (event.target.id) != "undefined" && event.target.id == "MemberOnlyAccessDenied") {
            blurBackground();
        }
    }
});

document.addEventListener('shown.bs.modal', function (event) {
    setMaxZindexForModal();
});

$(document).on("click", "[href^='#mktoForm_']", function (event) {
    event.preventDefault();
    isMarketoPopupTriggered = true;

    var btn_href = $(this).attr("href");
    var marketoFormShortId = "";
    var mktFormConfirmationMessage = "The form has been submitted successfully.";
    let marketoFormPromise = "";
    let successLink = parseMaketoPopupUrl(btn_href, "successLink");

    if (parseMaketoPopupUrl(btn_href, "message")) {
        mktFormConfirmationMessage = parseMaketoPopupUrl(btn_href, "message");
    }

    marketoFormPromise = getMarketoFormId(parseMaketoPopupUrl(btn_href, "mktoForm"));
    marketoFormPromise.then(
        function (value) {
            openMarketoModalForm(value, mktFormConfirmationMessage, successLink);
        },
        function (error) {
            console.error(error);
        }
    );
});

// HubSpot popup trigger (parallel to the Marketo one). Author links use href="#hsForm_<formName>#message_...#successLink_...".
$(document).on("click", "[href^='#hsForm_']", function (event) {
    event.preventDefault();

    var btn_href = $(this).attr("href");
    var hsFormConfirmationMessage = "The form has been submitted successfully.";
    let successLink = parseMaketoPopupUrl(btn_href, "successLink");

    if (parseMaketoPopupUrl(btn_href, "message")) {
        hsFormConfirmationMessage = parseMaketoPopupUrl(btn_href, "message");
    }

    var formName = parseMaketoPopupUrl(btn_href, "hsForm");

    getHubSpotFormId(formName).then(
        function (formGuid) {
            if (formGuid) {
                openHubSpotModalForm(formGuid, hsFormConfirmationMessage, successLink);
            }
        },
        function (error) {
            console.error(error);
        }
    );
});

function parseMaketoPopupUrl(mktUrl, key) {
    const arr = mktUrl.split("#").filter(Boolean);
    const result = {};

    arr.forEach((item) => {
        const firstnderscoreIndex = item.indexOf("_");
        const key = item.substring(0, firstnderscoreIndex);
        const value = item.substring(firstnderscoreIndex + 1);
        result[key] = value;
    });

    return result[key];
}

//Get Marketo form Id
function getMarketoFormId(formName) {

    var body = { "formName": formName };

    return new Promise((resolve) => {
        $.ajax({
            url: '/get-marketo-id',
            type: "POST",
            data: body,
            success: function (data) {
                resolve(data);
            },
            error: function (error) {
                resolve(error);
            }
        });
    });
}
//Get Marketo form Id

function openMarketoModalForm(marketoFormShortId, mktFormConfirmationMessage, successLink) {
    var existingForm = MktoForms2.getForm(marketoFormShortId);
    $('#marketo-popup .modal-body .mkto-form-container').hide();
    var currentMarketoFormLength = $('#marketo-popup .modal-body #mktoForm_' + marketoFormShortId + '_container').length;
    if (!existingForm && currentMarketoFormLength == 0) {
        jQuery('<div>', {
            id: "mktoForm_" + marketoFormShortId + "_container",
            class: "mkto-form-container"
        }).appendTo('#marketo-popup .modal-body');
        jQuery('<form>', {
            id: "mktoForm_" + marketoFormShortId,
        }).appendTo('#marketo-popup .modal-body #mktoForm_' + marketoFormShortId + '_container');
        jQuery('<div>', {
            class: "marketo-response-message",
        }).appendTo('#marketo-popup .modal-body #mktoForm_' + marketoFormShortId + '_container');

        MktoForms2.loadForm(marketoBaseUrl, marketoSubscriptionId, marketoFormShortId, function (form) {
            form.onSuccess(function (values, followUpUrl) {
                isMarketoPopupTriggered = false;
                form.getFormElem().hide();
                $('#mktoForm_' + marketoFormShortId + '_container').find(".marketo-response-message").html(mktFormConfirmationMessage);

                if (successLink) {
                    var linkElementId = 'mktoForm_success_' + marketoFormShortId
                    if (successLink.startsWith("_video_")) {
                        $("<a/>", {
                            id: linkElementId,
                            href: successLink,
                            target: '_blank'
                        }).appendTo('#mktoForm_' + marketoFormShortId + '_container');
                        $('#' + linkElementId).click();
                        $('#video_videoModal').modal('show');
                        var marketoPopup = document.getElementById('marketo-popup')
                        var marketoPopupModal = bootstrap.Modal.getInstance(marketoPopup);
                        marketoPopupModal.hide();
                    } else {
                        window.open(successLink, "_blank")
                    }
                }

                return false;
            });
        });
    } else {
        $('#marketo-popup .modal-body #mktoForm_' + marketoFormShortId + '_container').show();
        onMarketoFormReady(existingForm);
    }
}

function onMarketoFormReady(form) {
    if (isMarketoPopupTriggered) {
        var popupModalId = "#" + form.getFormElem()[0]?.closest('.modal')?.id;
        var marketoPopupModal = bootstrap.Modal.getInstance(popupModalId);
        if (!marketoPopupModal) {
            var popupModalEl = document.querySelector(popupModalId);
            marketoPopupModal = new bootstrap.Modal(popupModalEl);
        }

        marketoPopupModal.show();
    }
}

// Get HubSpot form GUID by form name
function getHubSpotFormId(formName) {
    return new Promise((resolve) => {
        $.ajax({
            url: '/get-hubspot-id',
            type: "POST",
            data: { "formName": formName },
            success: function (data) {
                resolve(data);
            },
            error: function () {
                resolve("");
            }
        });
    });
}

function waitForHubSpotForms(callback, retries = 20, interval = 250) {
    if (typeof hbspt !== "undefined" && hbspt.forms) {
        callback();
    } else if (retries > 0) {
        setTimeout(() => waitForHubSpotForms(callback, retries - 1, interval), interval);
    }
}

function showHubSpotPopupModal() {
    var popupEl = document.getElementById('hubspot-popup');
    var popupModal = bootstrap.Modal.getInstance(popupEl) || new bootstrap.Modal(popupEl);
    popupModal.show();
}

function openHubSpotModalForm(formGuid, hsFormConfirmationMessage, successLink) {
    var containerId = "hsForm_" + formGuid + "_container";
    var targetId = "hsForm_" + formGuid;

    $('#hubspot-popup .modal-body .hs-form-container').hide();

    if ($('#hubspot-popup .modal-body #' + containerId).length === 0) {
        jQuery('<div>', { id: containerId, class: "hs-form-container" }).appendTo('#hubspot-popup .modal-body');
        jQuery('<div>', { id: targetId, class: "hbspt-form-target" }).appendTo('#hubspot-popup .modal-body #' + containerId);
        jQuery('<div>', { class: "hubspot-response-message" }).appendTo('#hubspot-popup .modal-body #' + containerId);

        waitForHubSpotForms(function () {
            hbspt.forms.create({
                portalId: hubSpotPortalId,
                formId: formGuid,
                region: hubSpotRegion,
                target: '#' + targetId,
                formInstanceId: targetId,
                onFormSubmitted: function () {
                    $('#' + targetId).hide();
                    $('#' + containerId).find(".hubspot-response-message").html(hsFormConfirmationMessage);

                    if (successLink) {
                        if (successLink.startsWith("_video_")) {
                            var linkElementId = 'hsForm_success_' + formGuid;
                            $("<a/>", { id: linkElementId, href: successLink, target: '_blank' }).appendTo('#' + containerId);
                            $('#' + linkElementId).click();
                            $('#video_videoModal').modal('show');
                            var hsPopup = document.getElementById('hubspot-popup');
                            var hsPopupModal = bootstrap.Modal.getInstance(hsPopup);
                            if (hsPopupModal) {
                                hsPopupModal.hide();
                            }
                        } else {
                            window.open(successLink, "_blank");
                        }
                    }
                }
            });

            showHubSpotPopupModal();
        });
    } else {
        $('#hubspot-popup .modal-body #' + containerId).show();
        showHubSpotPopupModal();
    }
}

function showToast(message, timeSpan, type) {
    $("#waw-toast .toast-body").html(message);
    if (typeof (type) != "undefined" && type == "success") {
        $("#waw-toast").addClass("toast-success").removeClass("toast-fail");
    } else if (typeof (type) != "undefined" && type == "fail") {
        $("#waw-toast").addClass("toast-fail").removeClass("toast-success");
    } else {
        $("#waw-toast").removeClass("toast-success").removeClass("toast-fail");
    }

    $('#waw-toast').css("z-index", getMaxZIndex() + 1);

    var wawToast = document.getElementById('waw-toast');
    var wawToastInstance = bootstrap.Toast.getOrCreateInstance(wawToast);

    if (!isNaN(timeSpan)) {
        wawToastInstance._config.delay = timeSpan;
    } else {
        wawToastInstance._config.delay = 7000;
    }

    wawToastInstance.show();
}

function updateCartLinkInMenu() {
    let isDonationProductinCart = cookieMap().get("isDonationProductinCart");

    if (isDonationProductinCart == undefined) {
        $('.cart-link-update').each((i, obj) => {

            const BC_CART_ID = localStorage.getItem('bcCartId');
            const HAS_MEMBERSHIP_IN_CART = localStorage.getItem('hasMembershipInCart');
            const CART_LENGTH = localStorage.getItem('cartLength');

            var cartLink = window.location.origin + "/cart?cartId=";

            if (BC_CART_ID) {
                cartLink = cartLink + BC_CART_ID;
            }

            if (HAS_MEMBERSHIP_IN_CART === 'true') {
                cartLink = cartLink + "&membership=true";
            }

            if (BC_CART_ID) {
                $(obj).attr('href', cartLink);
                $(obj).addClass("cart-link-update-contents");
                $(obj).attr("data-after", CART_LENGTH == 0 ? " " : CART_LENGTH);
            } else {
                $(obj).removeClass("cart-link-update-contents");
            }
        });
    } else {
        document.cookie = "isDonationProductinCart=; SameSite=Strict; path=/; Secure; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
        localStorage.removeItem('bcCartId');
        localStorage.removeItem('hasMembershipInCart');
        localStorage.removeItem('cartLength');
    }
}

//Update cart link in menu

//Get Site Meta Data

function getSiteMetaData() {
    return new Promise((resolve, reject) => {
        $.ajax({
            url: AppConfig_AppPaths_WebURL.value + '/site/meta-data?alias=' + SiteMetaDataAlias.value,
            type: "GET",
            success: function (data) {
                resolve(data)
            },
            error: function (error) {
                reject(error)
            }
        });
    });
}

//Get Site Meta Data

//Get AccessToken

function getBCAccessToken() {
    const BCClientId = $("#IDPClients_BC_ClientId").val();
    const BCClientScope = $("#IDPClients_BC_Scope").val();

    return getAccessToken(BCClientId, BCClientScope);
}

function getSFAccessToken() {
    const SFClientId = $("#IDPClients_SF_ClientId").val();
    const SFClientScope = $("#IDPClients_SF_Scope").val();

    return getAccessToken(SFClientId, SFClientScope);
}

function getAccessToken(clientId, clientScope) {

    var body = { "clientId": clientId, "clientScope": clientScope };

    return new Promise((resolve, reject) => {
        $.ajax({
            url: '/account/accesstoken',
            type: "POST",
            data: body,
            success: function (data) {
                resolve(data)
            },
            error: function (error) {
                reject(error)
            }
        });
    });
}

//Get AccessToken

//Pagination scripts - start

function getPageRange(start, end) {
    return Array(end - start + 1).fill().map((v, i) => i + start);
}

function pagination(current, length, delta = 2) {
    if (length <= 0) {
        let pages = [];
        return pages;
    }

    const range = {
        start: Math.round(current - delta / 2),
        end: Math.round(current + delta / 2)
    };

    if (range.start - 1 === 1 || range.end + 1 === length) {
        range.start += 1;
        range.end += 1;
    }

    let pages = current > delta ? getPageRange(
        Math.min(range.start, length - delta),
        Math.min(range.end, length)
    ) : getPageRange(1, Math.min(length, delta + 1));

    const withDots = (value, pair) => pages.length + 1 !== length ? pair : [value];

    if (pages[0] !== 1) {
        pages = withDots(1, [1, '...']).concat(pages);
    }

    if (pages[pages.length - 1] < length) {
        pages = pages.concat(withDots(length, ['...', length]));
    }

    return pages;
}

let scrollOnPaginationToken = 0;

async function scrollOnPagination(id, scrollPaddingTop = 0) {
    const target = document.getElementById(id);
    if (!target) return;

    const token = ++scrollOnPaginationToken;
    const header = document.querySelector('header');
    const mainBar = header ? header.querySelector('.dh-tier2') : null;
    const targetTop = $(target).offset().top;
    const fullHeaderHeight = header ? header.offsetHeight : 0;
    const condensedY = mainBar ? targetTop - (mainBar.offsetHeight + scrollPaddingTop) : null;
    const headerHeight = condensedY !== null && condensedY >= window.scrollY ? mainBar.offsetHeight : fullHeaderHeight;
    const targetY = () => $(target).offset().top - (headerHeight + scrollPaddingTop);

    await scrollToPosition(targetY());

    if (token !== scrollOnPaginationToken || headerHeight <= 80) return;

    setTimeout(async () => {
        if (token === scrollOnPaginationToken) {
            await scrollToPosition(targetY());
        }
    }, 100);
}

function scrollToPosition(topPosition, behavior = 'smooth') {
    return new Promise((resolve) => {
        const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
        if (Math.abs(window.scrollY - Math.min(Math.max(0, topPosition), maxScroll)) < 1) {
            resolve();
            return;
        }
        const onScrollEnd = () => {
            window.removeEventListener('scrollend', onScrollEnd);
            resolve();
        };
        window.addEventListener('scrollend', onScrollEnd);
        window.scrollTo({
            top: Math.max(0, topPosition),
            behavior: behavior
        });
    });
}

//Pagination scripts - end

$(document).on("click", "[href^='_video_']", function (event) {
    event.preventDefault();
    var maxVideoHeight = 896;
    var videoHeight = window.innerHeight - 49;
    var addressValue = $(this).attr("href");
    addressValue = addressValue.replace('_video_', '');
    var $iframe = $('#videoEmbed');
    if ($iframe.length) {
        $iframe.attr('src', addressValue);
        if (videoHeight < maxVideoHeight) {
            $('#videoEmbed').css('height', videoHeight);
        }
        else {
            $('#videoEmbed').css('height', maxVideoHeight);
        }

        isVideoPopupOpened = true;
        return false;
    }
});

//Add click event listeners to elements with data-click-fn attribute
$(document).on("click", "[data-click-fn]", function (event) {
    const fnName = $(this).data("click-fn");
    if (window[fnName] && typeof window[fnName] === "function") {
        window[fnName](event);
    }
});

$(document).on("keypress", "[data-keypress-fn]", function (event) {
    const fnName = $(this).data("keypress-fn");
    if (window[fnName] && typeof window[fnName] === "function") {
        window[fnName](event);
    }
});

$('#video_videoModal').find('.btn-close').on("click", function (event) {
    var $iframe = $('#videoEmbed');
    if ($iframe.length) {
        $iframe.attr('src', '');
    }

    isVideoPopupOpened = false;
});

$("img").on("load", function () {
    loadVideoPlayButtons();
    loadVideoPlayButtons(true);
});

function loadVideoPlayButtons(isOnboardingVideo = false) {
    var popIndex = 0;

    const videoPrefix = isOnboardingVideo ? '_onboardingvideo_' : '_video_';
    const modalTarget = isOnboardingVideo ? '#onboarding_video_videoModal' : '#video_videoModal';
    const popIdPrefix = isOnboardingVideo ? 'popOnboardingVideoID' : 'popVideoID';

    $('a').each(function () {
        var value = $(this).attr('href');
        if (value != undefined) {
            if (value.startsWith(videoPrefix)) {
                $(this).attr('data-bs-toggle', 'modal')
                $(this).attr('data-bs-target', modalTarget)
                if ($(this).html().toLowerCase().includes('<img')) {
                    popIndex = popIndex + 1;
                    var imageElement = $(this).children();
                    if (imageElement.length > 0 && imageElement[0].naturalHeight != 0) {
                        var imgHeight = imageElement.innerHeight();
                        var isPlayInserted = $('#' + popIdPrefix + popIndex);
                        if (imgHeight > 0 && !isPlayInserted.length) {
                            $(this).append('<a href="#" class="ColFixedWidthIcon" id="' + popIdPrefix + popIndex + '" style="height:' + imgHeight + 'px;"><img src="/img/icons/video-play.svg" alt="play"/></a>');
                        }
                    }
                }
            }
        }
    });
}

// Validate Url
function isValidUrl(string) {
    let url;

    try {
        url = new URL(string);
    } catch (_) {
        return false;
    }

    return url.protocol === "http:" || url.protocol === "https:";
}

function checkFlexGap() {
    var flex = document.createElement("div");
    flex.style.display = "flex";
    flex.style.flexDirection = "column";
    flex.style.rowGap = "1px";

    flex.appendChild(document.createElement("div"));
    flex.appendChild(document.createElement("div"));

    document.body.appendChild(flex);
    var isSupported = flex.scrollHeight === 1;
    flex.parentNode.removeChild(flex);

    return isSupported;
}

window.onscroll = function (event) {
    if (isFirstBrowserScroll && window.location.hash) {
        event.preventDefault();
        var scrollTopMargin = 0;

        // Need more top scroll margin for Glossary and Pay Equity widgets.
        var payEquityElement = $(window.location.hash).parents("#payEquityList").first();
        if (payEquityElement) {
            scrollTopMargin += payEquityElement.find(".payEquityAlphabet").outerHeight() ?? 0;
        }
        // Need more top scroll margin for Glossary and Pay Equity widgets.

        setTimeout(function () { scrollOnPagination(window.location.hash.replace('#', ''), scrollTopMargin); }, 50);
        isFirstBrowserScroll = false;
    }

    isFirstBrowserScroll = false;

    hidePopoverOnScroll();
};

function triggerURLScroll() {
    if (window.location.hash) {
        setTimeout(function () {
            if (isFirstBrowserScroll) {
                window.scrollTo(0, window.pageYOffset > 1 ? window.pageYOffset - 1 : window.pageYOffset + 1);
            }
        }, 1500);
    }
}


// Case insensitive Array indexof
caseInsensitiveIndexOf = (arr, q) => arr.findIndex(item => q.toLowerCase() === item.toLowerCase());

isNullOrWhitespace = (input) => {
    return !input || !input.trim();
}

$(document).ready(function () {
    if (typeof widgetConsentsTobeSetup !== "undefined" && widgetConsentsTobeSetup.length > 0) {
        widgetConsentsTobeSetup.forEach(widgetConsentsAppSetup);
    }
});

cookieMap = () => {
    return new Map(document.cookie.split('; ').map(v => v.split(/=(.*)/s).map(decodeURIComponent)));
}

function widgetConsentsAppSetup(item) {

    let widgetConsentApp = Vue.createApp({
        data() {
            return {
                item: item,
                id: item.id,
                itemId: item.itemId,
                isLoading: true,
                isGivenConsent: item.isGivenConsent,
                consent: item.consent,
                isLoading: true,
                apiUrl: window.location.origin + "/WaW.Cms.Modules/CommonApi/AddWidgetInsights",
                canShowConsentForm: item.canShowConsentForm
            }
        },

        methods: {

            async logConsent(consentValue) {
                return new Promise((resolve) => {

                    var body =
                    {
                        "insightsItemId": this.itemId,
                        "consent": consentValue,
                        "pageUrl": window.location.pathname
                    };

                    $.ajax({
                        url: this.apiUrl,
                        type: "POST",
                        dataType: "json",
                        headers: {
                            RequestVerificationToken:
                                $('input:hidden[name="__RequestVerificationToken"]').val()
                        },
                        data: body,
                        success: function (data) {
                            resolve(data);
                        },
                        error: function (error) {
                            resolve(error);
                        },
                        complete: (data) => {
                            this.consent = consentValue;
                            this.closeConsent();
                            resolve(data);
                        }
                    });
                });
            },

            setConsentCookie() {
                if (cookieMap().get("widgetConsent") == undefined) {

                    document.cookie = "widgetConsent=" + this.itemId + ">" + this.consent + "; SameSite=Strict; path=/; Secure;";

                } else {
                    var existingCookie = cookieMap().get("widgetConsent");

                    existingCookie = existingCookie + "||" + this.itemId + ">" + this.consent;

                    document.cookie = "widgetConsent=" + existingCookie + "; SameSite=Strict; path=/; Secure;";
                }
            },

            closeConsent() {
                this.setConsentCookie();
                this.canShowConsentForm = false;
            }
        },

        computed: {

        },

        watch: {

        },

        created() {
            if (this.isGivenConsent) {
                this.canShowConsentForm = this.consent == "no";
            }
            else {
                var existingCookie = cookieMap().get("widgetConsent");
                if (existingCookie && existingCookie.indexOf(this.itemId) > -1) {
                    this.canShowConsentForm = existingCookie.split("||")[existingCookie.split("||").length - 1].split(">")[1] == "no";
                }
            }

            this.isLoading = false;
        },

        mounted() {

        },
    });

    widgetConsentsMountedApp['id_' + item.itemId] = widgetConsentApp.mount('#' + item.id + '_' + item.itemId);
}

function hidePopoverOnScroll() {
    try {
        var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
        popoverTriggerList.map(function (popoverTriggerEl) {
            if (popoverTriggerEl.attributes["data-bs-content"] != undefined) {
                var popover = bootstrap.Popover.getInstance(popoverTriggerEl);
                popover.hide();
            }
        });
    }
    catch (ex) {
        console.log(ex);
    }
}

function onFooterSubClose() {
    var cookieName = "hideFooterSubscription=true;";
    if ($("#footerSub").hasClass("sticky-bottom")) {
        cookieName = "makeFooterSubscriptionStatic=true;";
        $("#footerSub").removeClass("sticky-bottom")
    }

    var expiryDate = new Date();
    expiryDate.setTime(expiryDate.getTime() + (24 * 60 * 60 * 1000));
    document.cookie = cookieName + " SameSite=Strict; path=/; Secure; expires=" + expiryDate.toUTCString(); +";";
    $("#footerSub").remove();
}

// Foundation sticky tab (rendered by _FoundationStickyTab.cshtml)
function setFoundationPanelOpen(open) {
    var $panel = $("#foundationStickyPanel");
    var $tab = $("#foundationStickyTab");
    if (!$panel.length || !$tab.length) return;

    $panel.toggleClass("open", open).attr("aria-hidden", String(!open));
    $tab.attr("aria-expanded", String(open));

    if (open) {
        $panel.find(".fst-close").trigger("focus");
    } else {
        $tab.trigger("focus");
    }
}

function onFoundationTabToggle() {
    setFoundationPanelOpen(!$("#foundationStickyPanel").hasClass("open"));
}

function onFoundationTabClose() {
    setFoundationPanelOpen(false);
}

$(document).on("keydown", function (event) {
    if (event.key === "Escape" && $("#foundationStickyPanel").hasClass("open")) {
        setFoundationPanelOpen(false);
    }
});

$(document).on("click", function (event) {
    if ($("#foundationStickyPanel").hasClass("open") && !$(event.target).closest(".foundation-sticky-tab").length) {
        setFoundationPanelOpen(false);
    }
});

function subscribeToNewsletter(emailSelector, validationContainerSelector = null) {
    return new Promise((resolve, reject) => {
        let subscriptionEmail = $(emailSelector).val();
        var validationResult = validateSubscriptionEmail(subscriptionEmail);
        if (!validationResult.valid) {
            if (validationContainerSelector) {
                $(".subscription-signup-fail").addClass("d-none");
                $(validationContainerSelector).removeClass("d-none").html(`<p><span class="newsletter-email-error-msg">${validationResult.error}</span></p>`);
            } else {
                showToast(validationResult.error, 5000, "fail");
            }
            reject(validationResult.error);
            return;
        }

        if (validationContainerSelector) {
            $(validationContainerSelector).addClass("d-none").empty();
        }

        var body = { email: subscriptionEmail };

        $('.loading-overflow-add-cart').show().css("z-index", getMaxZIndex());

        $.ajax({
            url: '/subscribe/news-letter',
            method: "POST",
            data: body,
            headers: {
                RequestVerificationToken: $('input:hidden[name="__RequestVerificationToken"]').val()
            },
            success: function (data) {
                $('.loading-overflow-add-cart').hide();
                resolve(data);
            },
            error: function (error) {
                $('.loading-overflow-add-cart').hide();
                console.log(error);
                reject(error);
            }
        });
    });
}

function onNewsLetterSubscribe() {
    subscribeToNewsletter("#subscribe-email")
        .then((data) => {
            $(".subscription-cta, .subscription-content, .footer-sub-close").addClass("d-none");
            if (data) {
                $(".subscription-success").removeClass("d-none");
                var expiryDate = new Date();
                expiryDate.setTime(expiryDate.getTime() + (24 * 60 * 60 * 1000));
                document.cookie = "makeFooterSubscriptionStatic=true; SameSite=Strict; path=/; Secure; expires=" + expiryDate.toUTCString();

                setTimeout(() => {
                    $("#footerSub").fadeOut(1000, () => $("#footerSub").remove());
                }, 5000);
            } else {
                $(".subscription-fail").removeClass("d-none");
            }
        })
        .catch((error) => {
            console.error("Subscription failed:", error);
        });
}

function onNewsLetterWidgetSignUp() {
    let emailSelector = "#email-subscribe";
    let validationContainer = ".newsletter-email-validation";
    subscribeToNewsletter(emailSelector, validationContainer)
        .then((data) => {
            if (data) {
                $(".newsletter-input-container").addClass("d-none");
                $(".newsletter-signup-desc").addClass("d-none");
                $(".subscription-signup-success").removeClass("d-none");
                $(".subscription-signup-fail").addClass("d-none");
            } else {
                $(".subscription-signup-fail").removeClass("d-none");
            }
        })
        .catch((error) => {
            console.error("Sign-up failed:", error);
        });
}

function handleNewsLetterEnterKeyPress(event) {
    if (event.key === "Enter") {
        let inputId = event.target.id;
        if (inputId === "subscribe-email") {
            onNewsLetterSubscribe();
        } else if (inputId === "email-subscribe") {
            onNewsLetterWidgetSignUp();
        }
    }
}

const validateSubscriptionEmail = (email) => {
    var isValidEmail = String(email)
        .toLowerCase()
        .match(
            /^(?!.*[\\/])(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    if (!isValidEmail) {
        return { valid: false, error: "Please enter a valid email" };
    }
    return { valid: true, error: null };
};

function getCookie(name) {
    const cookieString = document.cookie;
    const cookies = cookieString.split('; ');

    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].split('=');
        const cookieName = cookie[0];
        const cookieValue = cookie[1];

        if (cookieName === name) {
            return cookieValue;
        }
    }

    return null;
}

let oldXHROpen = XMLHttpRequest.prototype.open;
XMLHttpRequest.prototype.open = function (method, url, async) {

    if (url.includes("api/carts")) {
        this.addEventListener('loadend', (event) => {
            cartUpdated(url, method, event);
        });
    }

    return oldXHROpen.apply(this, arguments);
}

function cartUpdated(url, method, event) {

    let payload = {
        "cartOutput": event.target.responseText,
        "method": method,
        "url": url,
        "pageUrl": window.location.href
    };

    $.ajax({
        url: '/shopping/track-cart-update',
        type: "POST",
        data: payload,
        dataType: "json",
        headers: {
            RequestVerificationToken:
                $('input:hidden[name="__RequestVerificationToken"]').val()
        },
    });

}

const debounce = (mainFunction, delay) => {
    let timer;
    return function (...args) {
        clearTimeout(timer);

        timer = setTimeout(() => {
            mainFunction(...args);
        }, delay);
    };
};

function sortArrayWithArray(arrayToSort, sortOrder) {

    const sorter = (a, b) => {
        return sortOrder.indexOf(a) - sortOrder.indexOf(b);
    }

    arrayToSort.sort(sorter);
    return arrayToSort;
}


Number.prototype.localizeCurrency = function () {
    try {
        let match = currencyPattern.match(/{(\d+):?C(\d*)}/);
        let fractionDigits = 2;
        if (match) {
            fractionDigits = match[2];
        }

        let currencyFormatter = Intl.NumberFormat(currentCulture, {
            style: 'currency',
            currency: currencyText,
            minimumFractionDigits: fractionDigits ?? 2
        });

        var indexOfText = currencyPattern.trim().indexOf("{1}");

        if (indexOfText == 0) {
            return `${currencyText} ${currencyFormatter.format(this)}`;
        } else if (indexOfText == -1) {
            return `${currencyFormatter.format(this)}`;
        } else {
            return `${currencyFormatter.format(this)} ${currencyText}`;
        }
    }
    catch (err) {
        console.log(err);
    }

    return "";
}

function convertTimeZone(date, tzString) {
    return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", { timeZone: tzString }));
}

function getCompanies(searchTerm) {
    return new Promise((resolve) => {
        $.ajax({
            url: AppConfig_AppPaths_WebURL.value + '/profile/company',
            type: "GET",
            data: { search: searchTerm },
            headers: {
                "X-Requested-With": "XMLHttpRequest",
                RequestVerificationToken:
                    $('input:hidden[name="__RequestVerificationToken"]').val()
            },
            success: function (result) {
                resolve(result.data);
            },
            error: function (error) {
                resolve(error);
            }
        });
    });
}

function openFeedbackPopup(event) {
    window.open(event.currentTarget.dataset.feedbackurl, 'Site Feedback', 'width=1000,height=700');
    return false;
}

function shareArticleOnSocialMedia(event) {
    event.preventDefault();

    const el = event.currentTarget;
    const url = el.href;
    const title = el.getAttribute("data-popup-title") || "Share";
    const width = el.getAttribute("data-popup-width") || 400;
    const height = el.getAttribute("data-popup-height") || 350;

    const left = window.screenX + (window.innerWidth - width) / 2;
    const top = window.screenY + (window.innerHeight - height) / 2;

    window.open(
        url,
        title,
        `width=${width},height=${height},top=${top},left=${left},resizable,scrollbars`
    );
}

function waitForMktoForms2(callback, retries = 20, interval = 250) {
    if (typeof MktoForms2 !== "undefined" && MktoForms2.whenReady) {
        callback();
    } else if (retries > 0) {
        setTimeout(() => waitForMktoForms2(callback, retries - 1, interval), interval);
    }
}

/**
* Animation on scroll function and init
*/
function aosInit() {
    if (typeof (AOS) != 'undefined') {
        AOS.init({
            disable: !window.enableScrollAnimation,
            duration: 600,
            easing: 'ease-in-out',
            once: true,
            mirror: false,
            offset: 60,
        });
    }
}

window.addEventListener('DOMContentLoaded', aosInit);

// Number counter animation

function wrapNumbersInElement(element) {
    element.childNodes.forEach(node => {
        if (node.nodeType === Node.TEXT_NODE) {
            // Detect numbers in text nodes, replace them with wrapped span
            const text = node.textContent;
            const replacedHTML = text.replace(/([0-9]{1,3}(?:,[0-9]{3})*(?:\.[0-9]+)?)/g, (match) => {
                const hasComma = match.includes(',');
                const dataSeparator = hasComma ? 'data-purecounter-formater="en-US" data-purecounter-separator="true"' : '';
                let decimalsAttr = '';
                const cleanNumber = match.replace(/,/g, '');
                const decimalMatch = cleanNumber.match(/\.(\d+)/);
                if (decimalMatch) {
                    const decimalPlaces = decimalMatch[1].length; // number of digits after decimal
                    decimalsAttr = `data-purecounter-separator="true" data-purecounter-decimals="${decimalPlaces}"`;
                }
                return `<span data-purecounter-start="0" data-purecounter-end="${cleanNumber}" ${dataSeparator} ${decimalsAttr} class="purecounter">${match}</span>`;
            });
            if (replacedHTML !== text) {
                // Replace text node with html containing wrapped numbers
                const wrapper = document.createElement('span');
                wrapper.innerHTML = replacedHTML;
                node.replaceWith(...wrapper.childNodes);
            }
        } else if (node.nodeType === Node.ELEMENT_NODE) {
            // Recursive call for child elements
            wrapNumbersInElement(node);
        }
    });
}

if (window.enableScrollAnimation) {
    document.querySelectorAll('.animate-number').forEach(elem => {
        wrapNumbersInElement(elem);
    });

    new PureCounter();
}

function openAffiliateFilters() {
    try {
        function isAddressAvailable(addr) {
            return addr && addr.country && String(addr.country).trim().length > 0;
        }

        const globalProfile = (typeof window !== 'undefined' && window.accountProfileInfo) ? window.accountProfileInfo : null;
        const homeAddr = globalProfile?.homeMailingAddress || null;
        const businessAddr = globalProfile?.businessAddress || null;

        let addrToUse = null;
        if (isAddressAvailable(homeAddr)) {
            addrToUse = homeAddr;
        } else if (isAddressAvailable(businessAddr)) {
            addrToUse = businessAddr;
        } else {
            addrToUse = null;
        }

        const countryName = addrToUse?.country ? String(addrToUse.country).trim() : "";
        const stateName = addrToUse?.state ? String(addrToUse.state).trim() : "";

        const affiliateCountries = countryDataset;
        const affiliateStates = stateDataset;

        function normalizeForMatch(s) {
            return String(s || "").normalize('NFKC').replace(/\s+/g, ' ').trim().replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
        }

        function findCountryId(fullName) {
            const n = normalizeForMatch(fullName);
            const match = affiliateCountries.find(c => normalizeForMatch(c.text) === n);
            return match ? match.id : null;
        }

        function findStateId(countryId, stateFullName) {
            if (!countryId) return null;
            const list = affiliateStates[countryId] || [];
            const n = normalizeForMatch(stateFullName);
            const match = list.find(s => normalizeForMatch(s.text) === n);
            return match ? match.id : null;
        }

        const countryId = findCountryId(countryName);
        const stateId = countryId ? findStateId(countryId, stateName) : null;

        let targetUrl = "/affiliates";

        if (countryId && stateId) {
            const params = new URLSearchParams();
            params.set("country", countryId.toLowerCase());
            params.set("state", stateId.toLowerCase());
            targetUrl += "?" + params.toString();
        } else {
            targetUrl += "#affiliate-form";
        }

        window.open(targetUrl, "_blank");
    } catch (err) {
        window.open("/affiliates", "_blank");
    }
}

function loadProfileDataCollectionPopup() {
    if (window.suppressPopups) return;
    if (!window.wawUserPersonId) return;
    if (typeof window.pdcSkipCookieExists !== 'function') return;
    if (window.pdcSkipCookieExists()) return;

    $.ajax({
        url: '/profile/next-popup-field',
        method: 'GET',
        data: { path: window.location.pathname },
        success: function (data, _textStatus, xhr) {
            if (!data) return;
            var contentType = xhr.getResponseHeader('Content-Type') || '';
            if (contentType.indexOf('application/json') !== -1) {
                if (data.cookieExpirationMinutes > 0 && typeof window.setPdcSkipCookie === 'function') {
                    window.setPdcSkipCookie(data.cookieExpirationMinutes);
                }
            } else if (data.trim()) {
                $('body').append(data);
                window.initPdcPopup && window.initPdcPopup();
            }
        }
    });
}